import Notification from '@rio-cloud/rio-uikit/Notification';

import { getDisplayMessages } from '../../../../configuration';
import type { RootDispatch, RootState } from '../../../../configuration/setup/store';
import { apiCallAction } from '../../api/redux/api.redux';
import { ApiCalls } from '../../api/redux/types';
import { postSubscriptionCancel } from '../../api/subscription/subscriptionCalls';
import { fetchContractsThunk } from '../../common/termedLevel/termedLevel.thunk';
import type { TermedLevel } from '../../common/termedLevel/types';
import { getPaymentMethodRequired } from './redux/contract.redux';

type ContractToTerminate = Pick<TermedLevel, 'productId' | 'resourceId'>;
const CONTRACT_REFRESH_DELAY_MS = 5000;

export const terminateContractNowThunk =
    (contract: ContractToTerminate) => (dispatch: RootDispatch, getState: () => RootState) => {
        const languageData = getDisplayMessages(getState());
        const refreshContractsSilently = () =>
            dispatch(
                fetchContractsThunk({
                    reportLoading: false,
                    paymentMethodRequired: getPaymentMethodRequired(getState()),
                })
            );

        dispatch(apiCallAction(ApiCalls.SUBSCRIPTION_CANCEL, true, false));
        return postSubscriptionCancel(contract.productId, [contract.resourceId])
            .then(() => {
                dispatch(apiCallAction(ApiCalls.SUBSCRIPTION_CANCEL, false, false));
                Notification.success(languageData['marketplace.contracts.terminateNow.success']);
                const immediateRefresh = refreshContractsSilently();
                setTimeout(refreshContractsSilently, CONTRACT_REFRESH_DELAY_MS);
                return immediateRefresh;
            })
            .catch(() => {
                dispatch(apiCallAction(ApiCalls.SUBSCRIPTION_CANCEL, false, true));
                Notification.error(languageData['marketplace.contracts.terminateNow.error']);
            });
    };
